import { QAFilterCriteria } from 'features/qa/types';

export const convertBackendFilter = (backendFilter: string): QAFilterCriteria => {
  if (backendFilter === 'open') {
    return 'opened';
  }

  return backendFilter as QAFilterCriteria;
};
